module.exports = __webpack_public_path__ + "images/file_icons_v2/sav-e0a343a01364a2fde75d429ab91628d8.svg";